import ReCAPTCHA from './Recaptcha';
import makeAsyncScriptLoader from './async';
var callbackName = 'onloadcallback';
var lang = typeof window !== 'undefined' && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=".concat(window.recaptchaOptions.lang) : '';
var url = "https://www.google.com/recaptcha/api.js?onload=".concat(callbackName, "&render=explicit").concat(lang);
var globalName = 'grecaptcha';
export default makeAsyncScriptLoader(ReCAPTCHA, url, {
  callbackName: callbackName,
  globalName: globalName,
  exposeFuncs: ['getValue', 'reset', 'execute']
});